import React, { useEffect } from "react";
import { BiArrowToRight, BiSolidArrowToRight } from "react-icons/bi";
import { BsArrowBarRight } from "react-icons/bs";
import { FiArrowRight } from "react-icons/fi";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { useServiceData } from "../context/ServiceDataContext";
import ServicePopUp from "./ServicePopUp";

const ServicesShowcase = ({ data, superData }) => {
  const { topHeading, mainHeading, subServices = [], p = "" } = data;
  const { getServiceById, getServiceByCategory } = useServiceData();
  const { pathname, search } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();

  // Extract service ID from query parameter
  const urlParams = new URLSearchParams(search);
  const serviceId = urlParams.get("service");

  const service = getServiceById(`${pathname.split("/")[1]}`, serviceId || id);
  const services = getServiceByCategory(`${pathname.split("/")[1]}`);

  console.log("Service ID from query:", serviceId);
  console.log("Service data:", services);

  // State for popup visibility - sync with URL query
  const [popActive, setPopActive] = React.useState(false);

  // Sync popup state with URL query parameter
  useEffect(() => {
    if (serviceId && service) {
      setPopActive(true);
    } else {
      setPopActive(false);
    }
  }, [serviceId, service]);

  const handlePopClose = () => {
    // Clear the service query parameter
    const urlParams = new URLSearchParams(search);
    urlParams.delete("service");
    const newSearch = urlParams.toString();

    // Update URL without the service query
    navigate(`${pathname}${newSearch ? "?" + newSearch : ""}`, {
      replace: true,
    });

    // Close popup
    setPopActive(false);
  };

  return (
    <>
      <div className="bg-white dark:bg-zinc-900 py-20  xl:px-35 px-10 relative overflow-hidden">
        {/* Header */}
        <div className=" mb-16">
          <h2 className="text-xl font-bold text-[#EE005B] mb-4 text-center xl:text-left">
            {topHeading}
          </h2>

          {/* Main Content Text */}
          <div className="max-w-5xl">
            <h1 className="xl:text-5xl text-4xl font-bold text-black dark:text-white leading-tight text-center xl:text-left">
              {mainHeading.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < mainHeading.split("\n").length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>
          </div>

          {/* Main Content Text */}
          <div className="max-w-5xl">
            <h1 className="text-2xl text-center xl:text-left text-black dark:text-white leading-relaxed">
              {p}
            </h1>
          </div>
        </div>

        {/* Services Grid */}
        <div className=" mt-20 w-full">
          {/* {subServices.map((column, columnIndex) => ( */}
          <div className="space-y-6 grid md:grid-cols-3 grid-cols-2 items-center w-full gap-6 mx-auto xl:mx-0 ">
            {superData.subServices.map((service, serviceIndex) => (
              <Link
                key={serviceIndex}
                to={`?service=${service.id}`}
                className=" w-fit group pointer-events-auto cursor-pointer inline-block"
              >
                <h3 className="xl:text-3xl md:text-xl text-lg font-bold text-black dark:text-white flex items-center gap-2">
                  {service.name}
                  <span className="inline-block -rotate-45 opacity-0 group-hover:opacity-100 duration-300">
                    <FiArrowRight />
                  </span>
                </h3>
                <div className="w-full overflow-x-hidden hidden xl:block">
                  <div className="w-[200%] h-0.5 border-b-4 border-dotted border-gray-400 dark:border-gray-600 group-hover:-translate-x-[10%] duration-1000 group-hover:border-[#EE005B] "></div>
                </div>
              </Link>
            ))}
          </div>
          {/* ))} */}
        </div>
      </div>
      {service && (
        <ServicePopUp
          open={popActive}
          onClose={handlePopClose}
          badge={pathname.split("/")[1]}
          title={service?.subHeading || service?.name || "Service"}
          description={
            service?.p || service?.description || "Service description"
          }
          listData={service?.ul || { title: "Services", items: [] }}
          id={service?.id}
          backToPrevious={service?.backToPrevious || false}
          imageSrc={service?.imgSrc || services?.lottieSrc || ""}
        />
      )}
    </>
  );
};

export default ServicesShowcase;
